module.exports = __webpack_public_path__ + "img/vasty-cover.3abbecff.jpg";